/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import getPosition from '@/utils/crossBrowserHelpers/getPosition';
import scrollToElem from '@/utils/crossBrowserHelpers/scroll';
import { CUSTOMER_REVIEWS_ID } from '../constants/sectionHash';

export const scrollToCustomerReviews = () => {
  const title = document.getElementById(CUSTOMER_REVIEWS_ID);

  if (title != null) {
    const client = getPosition(title);

    if (client.y !== 0) {
      scrollToElem(client.y - 125);
    }
  }
};
